/** These strings aren't customer-facing: these don't need to be localized. */
export const DEV_NOTIFICATION = {
  name: 'Snake',
  contents: 'This is a demo notification for testing purposes',
  companyLogoUrl:
    'https://static.wikia.nocookie.net/logopedia/images/5/55/Metal_Gear.svg/revision/latest/scale-to-width-down/350?cb=20190622001821',
};
